export default __webpack_public_path__ + "static/media/database.2f9d4365.svg";